// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-6.use[1]!../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-6.use[2]!../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-6.use[3]!./icons.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("de504b22", content, true, {});